// Open to any better suggestion for line 4 to line 16, want to avoid using `let`
// eslint-disable-next-line check-file/filename-blocklist
let isVideo = false;
let isAudio = false;
let videoTag: HTMLVideoElement | null = null as unknown as HTMLVideoElement;
const initVideoTag = (): HTMLVideoElement | null => {
    if (videoTag === null) {
        videoTag = document.getElementById('Activity--MediaTypeTester') as HTMLVideoElement;
    }

    if (videoTag) {
        videoTag.addEventListener('canplay', () => {
            isVideo = (videoTag?.videoHeight || 0) > 0;
            isAudio = videoTag?.videoHeight === 0;
        });
        videoTag.addEventListener('error', () => {
            isVideo = false;
            isAudio = false;
        });
    }
    return videoTag;
};

const knownImageFormats = ['.jpg', '.jpeg', '.png', '.tiff', 'bmp'];
const knownVideoFormats = ['.mp4', '.webm', 'mpg', '.mpeg', '.mov', '.avi', '.mov'];

export enum ActivityMediaType {
    Image,
    Audio,
    Video,
    None,
}

const cleanupVideo = (videoElement: HTMLVideoElement | null) => {
    if (!videoElement) return;
    try {
        videoElement.pause();
        videoElement.setAttribute('src', '');
    } catch (e) {
        // do nothing
    }
};

const getMediaTypeDetails = async (srcUrl?: string): Promise<ActivityMediaType> => {
    if (!srcUrl || srcUrl.length === 0) return ActivityMediaType.None;
    const srcLower = srcUrl.trim().toLowerCase();
    for (const imageFormat of knownImageFormats) {
        if (srcLower.includes(imageFormat)) {
            return ActivityMediaType.Image;
        }
    }
    for (const videoFormat of knownVideoFormats) {
        if (srcLower.includes(videoFormat)) {
            return ActivityMediaType.Video;
        }
    }

    videoTag = initVideoTag();
    // This case should never happen
    if (!videoTag) {
        return ActivityMediaType.None;
    }

    videoTag.setAttribute('src', srcUrl);

    try {
        const playPromise = videoTag.play();
        if (playPromise !== undefined) {
            await playPromise
                .then((_) => {
                    cleanupVideo(videoTag);
                })
                .catch((error) => {
                    cleanupVideo(videoTag);
                });
        }

        if (isVideo) return ActivityMediaType.Video;
        if (isAudio) return ActivityMediaType.Audio;
    } catch (e) {
        // Do nothing
    }
    return ActivityMediaType.None;
};

export default getMediaTypeDetails;
